
define('ldsh!modules/integrations/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div id="integrations" class="panel panel-default">\n  <div class="row-fluid">\n    <div class="span12">\n      <ul class="breadcrumb">\n        <li><a class="i18n" data-i18n="PUBLIC.PRODUCTS.LBL_PRODUCTS" href="/products"></a></li>\n        <li data-i18n="INTEGRATIONS.TITLE" class="active i18n"></li>\n      </ul>\n    </div>\n  </div>\n  <div class="panel-heading integrations__header p0">\n    <h1>\n      <i class="md-icon md-icon-list"/></i>\n      <span class="i18n" data-i18n="INTEGRATIONS.TITLE"></span> <span class="ml-5 f13 gris">(' +
((__t = ( groupId )) == null ? '' : __t) +
')</span>\n    </h1>\n    <div id="products-company-selector" class="col-xs-12 col-sm-12 col-md-6 col-lg-5 text-right"></div>\n  </div>\n\n  <div class="panel-body">\n    <ul class="nav nav-tabs flex--tabs" role="tablist">\n      ';
 if (zapierEnabled) { ;
__p += '\n      <li role="presentation" class="' +
__e(((activeTab === 'zapier') ? 'active' : '')) +
'" style="max-width: 33.3%">\n        <a href="' +
__e( baseUrl ) +
'/service/zapier">Zapier</a>\n      </li>\n      ';
 } ;
__p += '\n      ';
 if (shopifyEnabled) { ;
__p += '\n      <li role="presentation" class="' +
__e(((activeTab === 'shopify') ? 'active' : '')) +
'" style="max-width: 33.3%">\n        <a href="' +
__e( baseUrl ) +
'/service/shopify">Shopify</a>\n      </li>\n      ';
 } ;
__p += '\n      ';
 if (APIsEnabled) { ;
__p += '\n      <li role="presentation" class="' +
__e(((activeTab === 'api') ? 'active' : '')) +
'" style="max-width: 33.3%">\n        <a href="' +
__e( baseUrl ) +
'/service/api">APIs</a>\n      </li>\n      ';
 } ;
__p += '\n    </ul>\n    <div id="modal__container"></div>\n    <div id="integrations-tab-content" class="tab-content integrations__tab__content">\n      <div class="spinner__container" style="min-height: 400px">\n        <i class="ri-loader-4-fill fa-spin"></i>\n      </div>\n    </div>\n\n  </div>\n</div>\n\n';

}
return __p
};});

